import React from "react";
import "./user.css";
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import { isEscapeToInnerPeaceGame } from "../login/escapeLocalGuestRouting";

function USER({ children }) {
  const location = useLocation();

  const { companyLogoUrl, backButtonUrl } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);
  const isLoginRoute = location.pathname === "/" || /^\/login\/?$/i.test(location.pathname);
  const shouldHideLegacyChrome =
    isLoginRoute && isEscapeToInnerPeaceGame(user?.gameId);
  const fromMobileAppInUrl =
    String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
    "true";
  const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
  const persistedFromMobileApp = (() => {
    try {
      const persisted = JSON.parse(
        sessionStorage.getItem("userData") || "{}"
      );
      return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
    } catch {
      return false;
    }
  })();
  const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;
  const isLeaderboardRoute = /^\/leaderboard\/?$/.test(location.pathname);
  const leaderboardBackHref = String(process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "") || "/";

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  return (
    <>
      {!shouldHideLegacyChrome && (
        <header className="upperaction">
          <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={companyLogoUrl} className="logo-holder" alt="Company logo" /></a>
          {!isFromMobileApp && (
            <div className="back-holder">
              <a href={isLeaderboardRoute ? leaderboardBackHref : backButtonUrl}>
                <button
                  type="button"
                  className="back-default"
                >
                  Back
                </button>
              </a>
            </div>
          )}
        </header>
      )}
      <div key="user-content-shell">{children}</div>
    </>
  );
}

export default USER;
